import { render, staticRenderFns } from "./GlobalPagination.vue?vue&type=template&id=4ecb81c3&scoped=true"
import script from "./GlobalPagination.vue?vue&type=script&lang=js"
export * from "./GlobalPagination.vue?vue&type=script&lang=js"
import style0 from "./GlobalPagination.vue?vue&type=style&index=0&id=4ecb81c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecb81c3",
  null
  
)

export default component.exports